import React from 'react';
import ClientsTable from './ClientsTable';
import DocumentTitle from 'react-document-title';
import SectionHeader from 'components/text/SectionHeader';
import styled from 'styled-components';
import Button from 'components/common/Button';
import Icon from 'components/common/Icon';
import NoStudioYet from 'components/common/NoStudioYet';
import ClientForm from 'components/forms/ClientForm';
import Card from 'antd/lib/card';
// APOLLO
import createClient from 'ApolloClient/Mutations/createClient';
import { graphql } from 'react-apollo';
import message from 'antd/lib/message';
import getClientsQuery from 'ApolloClient/Queries/getClients';
import ErrorHelpers from 'lib/helpers/ErrorHelpers';
import InviteArea from '../app-studio/InviteArea';

const Container = styled.div`
  height: 100%;
  width: 900px;
  max-width: 100%;
  margin: auto;
  padding: 20px;
  padding-bottom: 20px;
`;
const CancelLink = ({ onClick }) => (
  <div style={{ marginBottom: 15 }}>
    <a style={{ fontSize: 16 }} onClick={onClick}>
      <Icon type="left" style={{ fontSize: 14 }} />
      CANCEL
    </a>
  </div>
);

let requiredFields = ['email', 'firstName', 'lastName'];

class AppClients extends React.PureComponent {
  state = {
    showForm: false,
  };

  toggleForm = () => {
    this.setState({ showForm: !this.state.showForm });
  };

  postMutationUpdate = (proxy, { data }) => {
    // will update local apollo cache after the mutation. see apollo docs.
    const localData = proxy.readQuery({
      query: getClientsQuery,
      variables: {},
    });
    localData.clients.push(data.createClient);
    proxy.writeQuery({
      query: getClientsQuery,
      data: localData,
    });
  };

  handleCreateClient = async params => {
    let variables = {
      params,
    };
    let res;

    try {
      res = await this.props.createClient({ variables, update: this.postMutationUpdate });
    } catch (err) {
      return ErrorHelpers.handleError(err);
    }
    message.success('Client was created.');
    this.toggleForm();
  };

  handleSubmit = params => {
    // do validation
    if (!params.email) {
      return message.error('Email is required.');
    }
    if (!params.firstName) {
      return message.error('First name is required.');
    }
    if (!params.lastName) {
      return message.error('Last name is required.');
    }
    this.handleCreateClient(params);
  };

  render() {
    const { currentUser } = this.props;

    if (!currentUser.organization || !currentUser.organization._id) {
      return <NoStudioYet />;
    }

    if (this.state.showForm) {
      return (
        <DocumentTitle title="Clients">
          <Container>
            <CancelLink onClick={this.toggleForm} />
            <Card style={{ width: 500, maxWidth: '100%' }}>
              <ClientForm handleSubmit={this.handleSubmit} client={null} />
            </Card>
          </Container>
        </DocumentTitle>
      );
    }

    return (
      <DocumentTitle title="Clients">
        <Container>
          <div style={{ position: 'relative' }}>
            <SectionHeader>Clients</SectionHeader>
            <Button style={{ position: 'absolute', right: 0 }} onClick={this.toggleForm} type="primary">
              + ADD CLIENT
            </Button>
          </div>
          <ClientsTable {...this.props} />
          <InviteArea currentUser={this.props.currentUser} />
        </Container>
      </DocumentTitle>
    );
  }
}

export default graphql(createClient, { name: 'createClient' })(AppClients);



// WEBPACK FOOTER //
// ./src/routes/app-clients/index.js